import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgPain10 = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 16,
	height: 16,
	viewBox: "0 0 16 16",
	fill: "none",
	...props,
	children: [/* @__PURE__ */ _jsx("g", {
		clipPath: "url(#clip0_4901_214548)",
		children: /* @__PURE__ */ _jsx("path", {
			d: "M4.41699 11.0002L5.50049 9.00024C6.00049 9.66691 6.50049 10.3336 7.00049 11.0002L8.00049 9.00024C8.68384 9.80991 8.81713 10.1906 9.50049 11.0002L10.5005 9.00024L12.0005 11.0002M4.50049 6.50024C5.23121 6.33955 5.87387 5.90786 6.29895 5.29216L6.50049 5.00024M9.50049 5.00024L10.1912 5.69104C10.5589 6.05876 11.0072 6.33581 11.5005 6.50024M14.6668 8.00016C14.6668 11.6821 11.6821 14.6668 8.00016 14.6668C4.31826 14.6668 1.3335 11.6821 1.3335 8.00016C1.3335 4.31826 4.31826 1.3335 8.00016 1.3335C11.6821 1.3335 14.6668 4.31826 14.6668 8.00016Z",
			stroke: "currentColor",
			strokeWidth: 1.33,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		})
	}), /* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
		id: "clip0_4901_214548",
		children: /* @__PURE__ */ _jsx("rect", {
			width: 16,
			height: 16,
			fill: "white"
		})
	}) })]
});
export default SvgPain10;
